import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { VopdData } from '../../../interfaces/vopd/vopd';
import { VopdApi } from '../api/vopd.api';


@Injectable({
  providedIn: 'root'
})
export class VopdService extends VopdData {
  constructor(private api: VopdApi) {
    super();
  }

  list<returnType>(url: string,params?:HttpParams): Observable<returnType> {
    if(!!params){
      return this.api.list(url,params);
    }
    else{
      return this.api.list(url);
    }
    
  }

  getById<type>(url:string,params?:HttpParams): Observable<type>{
    return this.api.getById(url,params);
}



  create<type,returnType>(url: string, data:type,params?:HttpParams): Observable<returnType> {
    if(!!params){
      return this.api.add<type,returnType>(url,data,params);
    }
    else{
      return this.api.add<type,returnType>(url,data);

    }

  }

  update<type,returnType>(url: string, data:type,params?:HttpParams): Observable<returnType> {
    if(!!params){
      return this.api.update<type,returnType>(url,data,params);
    }
    else{
      return this.api.update<type,returnType>(url,data);
    }
    
  }

  

 
}



  